import SignalType from "./models/SignalType";
import type KnxProductData from "./KnxProductdata";
import { ChannelType } from "./models/ChannelType";
import KnxRules from "./models/KnxRules";
import KnxInstanceData, { ValueLevels } from "./models/KnxInstanceData";
import KnxRule from "./models/KnxRule";

import Logger from "./Logger";
const logger = new Logger();

export type KnxProductConfigParam = { id: string; instanceId?: string; value: string };

export class KnxProductConfig {
  parent: KnxProductData;

  //
  // Rules from the Product-Server
  // TODO MWE 22.6.2024 load them !!!!!
  //

  rules: KnxRules | undefined;

  comObjs?: any; /// string => SingalTypeId
  params?: Array<KnxProductConfigParam>; // Default einstellung für Parameter
  type?: ChannelType;
  lastModified = new Date();

  constructor(knxProductData: KnxProductData) {
    this.parent = knxProductData;
  }

  toJSON(): any {
    const data: any = {};

    data.comObjs = this.comObjs;
    data.params = this.params;
    data.type = this.type;
    data.lastModified = this.lastModified;

    if (this.rules) {
      data.scripts = new Array<any>();
      this.rules._rules?.forEach((rule: KnxRule) => {
        const ruleData = rule.toJSON();
        data.scripts?.push(ruleData);
      });
    }

    return data;
  }

  fromJSON(data: any) {
    this.comObjs = data.comObjs;
    this.params = data.params;
    this.type = data.type;
    this.lastModified = data.lastModified;

    if (data.scripts) {
      this.rules = new KnxRules(this.parent);
      this.rules.init();

      data.scripts.forEach((ruleData: any) => {
        const rule = new KnxRule();
        rule.fromJSON(ruleData);
        this.rules?.set(rule);
      });
    }

    return this;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////

  get isEmpty(): boolean {
    return (
      this.params == undefined &&
      this.comObjs == undefined &&
      (this.rules?._rules?.size || 0) <= 0 &&
      this.type == undefined
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////

  loadParams(knxInstanceData: KnxInstanceData) {
    if (this.params) {
      logger.log("loadParams form template");

      const params = this.params;
      if (params) {
        params.forEach((param) => {
          knxInstanceData.setValue(ValueLevels.estadaPreset, param.value, param.id, param.instanceId || "", "");
        });
      }
    }
  }

  saveParams(knxInstanceData: KnxInstanceData) {
    const params: Array<KnxProductConfigParam> = [];

    for (let i in knxInstanceData.params) {
      const param = knxInstanceData.params[i];

      if (
        !param.setByScript &&
        (param.valueLevel == ValueLevels.interactive || param.valueLevel == ValueLevels.estadaPreset)
      )
        params.push({
          id: i,
          instanceId: undefined,
          value: param.value,
        });
    }

    for (let i in knxInstanceData.modules) {
      const module = knxInstanceData.modules[i];
      for (let j in module.params) {
        const param = module.params[j];
        if (
          !param.setByScript &&
          (param.valueLevel == ValueLevels.interactive || param.valueLevel == ValueLevels.estadaPreset)
        )
          params.push({
            id: j,
            instanceId: i,
            value: param.value,
          });
      }
    }

    this.params = params.length > 0 ? params : undefined;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////


  getSignalTypeNameMapping(id: string): string | undefined {
    const signalTypeName = this.comObjs ? this.comObjs[id] : undefined;
    return signalTypeName;
  }

  setSignalTypeNameMapping(id: string, newValue: string | undefined) {
    if (newValue) {
      if (!this.comObjs) {
        this.comObjs = {};
      }
      this.comObjs[id] = newValue;
    } else {
      if (this.comObjs) {
        delete this.comObjs[id];
      }
    }

    this.lastModified = new Date();
  }


  getSignalTypeMapping(id: string): SignalType | undefined {
    const signalTypeName = this.comObjs ? this.comObjs[id] : undefined;

    if (signalTypeName) {
      // if we found a mapping convert SignalType name to SignalType
      return SignalType.allSignalTypes.get(signalTypeName);
    }

    return undefined;
  }

  setSignalTypeMapping(id: string, newValue: SignalType | undefined) {
    this.setSignalTypeNameMapping(id, newValue ? newValue.name : undefined);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////

  get channelType(): ChannelType | undefined {
    return this.type;
  }

  set channelType(newValue: ChannelType | undefined) {
    if (newValue == ChannelType.Unknown) {
      this.type = undefined;
    } else {
      this.type = newValue;
    }
  }
}
